/**
 * @file システムエラーアラートダイアログの表示状態を管理するステート
 *
 * API呼び出し失敗やタイムアウト時などにエラーダイアログの表示/非表示を制御する。
 * apiTypeによりエラーの種別（通常エラー、オプション変更エラー、タイムアウト等）を識別し、
 * 適切なエラーメッセージをAlertDialogコンポーネントで表示する。
 */
import { atom } from 'recoil';

/** システムエラーアラートの表示情報を表す型 */
type Alert = {
  /** ダイアログが開いているかどうか */
  isOpen: boolean;
  /** エラーの種別（Constants.ApiType で定義される値が入る） */
  apiType: string;
};

/**
 * システムエラーアラートダイアログの状態を保持するRecoil atom。
 * APIエラー発生時にisOpenをtrue、apiTypeにエラー種別をセットすることで、
 * AlertDialogコンポーネントが対応するメッセージを表示する。
 */
export const alertState = atom<Alert>({
  key: 'alertState',
  default: {
    isOpen: false,
    apiType: '',
  },
});

export default alertState;
